/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Remove_User_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not remove the user." |
*
* @param {Partner_Admin_Remove_User_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_remove_user_error = /** @type {((inputs?: Partner_Admin_Remove_User_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Remove_User_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer konnte nicht entfernt werden.")
	return /** @type {LocalizedString} */ ("Could not remove the user.")
});